import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Locations extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	componentDidMount() {
    document.title = 'Diamonds Direct | Locations';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

	storeNav(page) {
    this.context.router.push('/' + page);
    // window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='Locations'>

						<div className="locations-wrapper">
							<div className="map-wrapper">
								<img src="https://ddw2.diamondsdirect.com/img/locations/map-background-5.png" className="map-background" />
								<div id="marker-austin" className="map-location-wrapper" onClick={() => this.storeNav('austin')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Austin,&nbsp;TX</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-birmingham" className="map-location-wrapper" onClick={() => this.storeNav('birmingham')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Birmingham,&nbsp;AL</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-charleston" className="map-location-wrapper" onClick={() => this.storeNav('charleston')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Charleston,&nbsp;SC</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-clt" className="map-location-wrapper double-wrapper">
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div onClick={() => this.storeNav('charlotte')}>
											<div className="store-name">Charlotte,&nbsp;NC</div>
											<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
										</div>
									</div>
								</div>
								<div id="marker-cleveland" className="map-location-wrapper" onClick={() => this.storeNav('cleveland')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Cleveland, OH</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-columbus" className="map-location-wrapper" onClick={() => this.storeNav('columbus')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Columbus, OH</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-dallas" className="map-location-wrapper double-wrapper">
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div onClick={() => this.storeNav('dallas')}>
											<div className="store-name">Dallas,&nbsp;TX</div>
											<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
										</div>
										<div className="horizontal-rule"></div>
										<div onClick={() => this.storeNav('frisco')}>
											<div className="store-name">Frisco,&nbsp;TX</div>
											<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
										</div>
									</div>
								</div>
								<div id="marker-indy" className="map-location-wrapper" onClick={() => this.storeNav('indianapolis')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Indianapolis, IN</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-hou" className="map-location-wrapper double-wrapper">
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div onClick={() => this.storeNav('baybrook')}>
											<div className="store-name">Houston,&nbsp;TX&nbsp;(Baybrook)</div>
											<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
										</div>
										<div className="horizontal-rule"></div>
										<div onClick={() => this.storeNav('houston')}>
											<div className="store-name">Houston,&nbsp;TX&nbsp;(Galleria)</div>
											<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
										</div>
									</div>
								</div>
								<div id="marker-kansas-city" className="map-location-wrapper" onClick={() => this.storeNav('kansas-city')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Kansas City, KS</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-nol" className="map-location-wrapper" onClick={() => this.storeNav('new-orleans')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">New Orleans, LA</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-okc" className="map-location-wrapper" onClick={() => this.storeNav('oklahoma-city')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Oklahoma City, OK</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-pit" className="map-location-wrapper" onClick={() => this.storeNav('pittsburgh')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Pittsburgh, PA</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-raleigh" className="map-location-wrapper" onClick={() => this.storeNav('raleigh')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Raleigh,&nbsp;NC</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-richmond" className="map-location-wrapper" onClick={() => this.storeNav('richmond')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Richmond,&nbsp;VA</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-stl" className="map-location-wrapper" onClick={() => this.storeNav('st-louis')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">St.&nbsp;Louis,&nbsp;MO</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-san" className="map-location-wrapper" onClick={() => this.storeNav('san-antonio')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">San&nbsp;Antonio,&nbsp;TX</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-vab" className="map-location-wrapper" onClick={() => this.storeNav('virginia-beach')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Virginia&nbsp;Beach,&nbsp;VA</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-boc" className="map-location-wrapper" onClick={() => this.storeNav('boca-raton')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Boca&nbsp;Raton,&nbsp;FL</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-globaldiamonds" className="map-location-wrapper" onClick={() => this.storeNav('jacksonville')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Jacksonville,&nbsp;FL</div>
										<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
									</div>
								</div>
								<div id="marker-gsc" className="map-location-wrapper" onClick={() => this.storeNav('greenville')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Greenville,&nbsp;SC</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-nva" className="map-location-wrapper" onClick={() => this.storeNav('tysons')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Tysons,&nbsp;VA</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
								<div id="marker-try" className="map-location-wrapper" onClick={() => this.storeNav('troy')}>
									<div className="marker-wrapper">
										<div className="store-marker">&nbsp;</div>
									</div>
									<div className="store-label">
										<div className="store-name">Troy,&nbsp;MI</div>
										<div className="store-link">Visit Store Page</div>
									</div>
								</div>
							</div>
							<div className="appointmentButtonWrapper">
								<div className="appointmentButton" onClick={() => this.internalNav('virtual')}>Request an Appointment</div>
							</div>
						</div>
						<div className="locations-grid">
							<div className="block-link-section">
								<div className="block-link" onClick={() => this.storeNav('austin')}>
									<div className="location-block">Austin, TX</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('birmingham')}>
									<div className="location-block">Birmingham, AL</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('boca-raton')}>
									<div className="location-block">Boca Raton, FL</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('charleston')}>
									<div className="location-block">Charleston, SC</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('charlotte')}>
									<div className="location-block">Charlotte, NC</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('cleveland')}>
									<div className="location-block">Cleveland, OH</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('columbus')}>
									<div className="location-block">Columbus, OH</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('dallas')}>
									<div className="location-block">Dallas, TX</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('frisco')}>
									<div className="location-block">Frisco, TX</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('greenville')}>
									<div className="location-block">Greenville, SC</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('baybrook')}>
									<div className="location-block double-block">
										<div className="block-header">Houston, TX</div>
										<div className="block-subheader">Baybrook</div>
									</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('houston')}>
									<div className="location-block double-block">
										<div className="block-header">Houston, TX</div>
										<div className="block-subheader">Galleria</div>
									</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('indianapolis')}>
									<div className="location-block">Indianapolis, IN</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('jacksonville')}>
									<div className="location-block">Jacksonville, FL</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('kansas-city')}>
									<div className="location-block">Kansas City, KS</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('new-orleans')}>
									<div className="location-block">New Orleans, LA</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('oklahoma-city')}>
									<div className="location-block">Oklahoma City, OK</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('pittsburgh')}>
									<div className="location-block">Pittsburgh, PA</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('raleigh')}>
									<div className="location-block">Raleigh, NC</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('richmond')}>
									<div className="location-block">Richmond, VA</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('st-louis')}>
									<div className="location-block">St. Louis, MO</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('san-antonio')}>
									<div className="location-block">San Antonio, TX</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('troy')}>
									<div className="location-block">Troy, MI</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('tysons')}>
									<div className="location-block">Tysons, VA</div>
								</div>
								<div className="block-link" onClick={() => this.storeNav('virginia-beach')}>
									<div className="location-block">Virginia Beach, VA</div>
								</div>
							</div>
						</div>
						<div className='locationsFooter'>
							<div className='footerLine'>Want a store near you?</div>
							<div>
								<div className='footerLine'>Drop us a </div>
								<div className='footerButton'>
									<Mailto email={PRIMARY_CUSTOMER_SERVICE}>hint</Mailto>
								</div>
							</div>
						</div>
		</div>;
	}
}
export default Locations;

function mapStateToProps(state) {
  return {

  };
}

export const LocationsContainer = connect(
  mapStateToProps,
  allActionCreators
)(Locations);


// WEBPACK FOOTER //
// ./src/components/views/locations/Locations.jsx